/**
 * @file Account setup view.
 */

import React from 'react';
import Helmet from 'react-helmet';

import LandingPageLayout from '../../apps/pro/components/LandingPageLayout';
import ContentWrap from '../../components/global/ContentWrap';
import AccountSetupContainer from '../../containers/auth/AccountSetupContainer';
import ContentHeader from '../../components/global/ContentHeader';
import FadeInLeft from '../../components/global/transitions/FadeInLeft';

const AccountSetupView = () => (
  <LandingPageLayout>
    <Helmet>
      <title>Account Setup &ndash; Waldo</title>
    </Helmet>

    <FadeInLeft in appear>
      <ContentWrap size="sm">
        <ContentHeader title="Complete your registration" />

        <AccountSetupContainer />
      </ContentWrap>
    </FadeInLeft>
  </LandingPageLayout>
);

export default AccountSetupView;
